module.exports = __webpack_public_path__ + "img/default.50e51f70.jpg";